(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5929],{

/***/ 19698:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reviews",
      function () {
        return __webpack_require__(49610);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5426:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/nubrakes-van-house-800-num.3fec1ca8.jpg","height":571,"width":1003,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAP/xAAeEAABBAEFAAAAAAAAAAAAAAABAAIDEQUGISIxYf/EABUBAQEAAAAAAAAAAAAAAAAAAAID/8QAFxEBAQEBAAAAAAAAAAAAAAAAAQACMf/aAAwDAQACEQMRAD8AloyspkG48vlhAYS6Vj+ZHdDagL8KIinsBl2//9k=","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 68663:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H4": function() { return /* binding */ YelpButton; },
/* harmony export */   "Ig": function() { return /* binding */ ButtonOutline; },
/* harmony export */   "Op": function() { return /* binding */ ViewAllCitiesButton; },
/* harmony export */   "zx": function() { return /* binding */ Button; }
/* harmony export */ });
/* unused harmony export LearnMoreButton */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);






var Button = function(_param) {
    var children = _param.children, className = _param.className, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children",
        "className",
        "disabled"
    ]);
    var disabledClassName = "disabled:bg-green-300 disabled:cursor-not-allowed";
    var baseClassName = "inline-block justify-center bg-lime hover:bg-green-600 text-white py-2 text-lg font-semibold px-5 rounded";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        disabled: disabled,
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(baseClassName, disabledClassName, className)
    }, rest), {
        children: children
    }));
};
var LearnMoreButton = function(param) {
    var children = param.children;
    var baseClassName = "ml-1 inline-block justify-center bg-blue-900 text-white text-sm px-2 rounded";
    return /*#__PURE__*/ _jsx("button", {
        className: classNames(baseClassName),
        children: children
    });
};
var ButtonOutline = function(_param) {
    var children = _param.children, className = _param.className, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children",
        "className",
        "disabled"
    ]);
    var disabledClassName = "opacity-50 cursor-not-allowed";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        disabled: disabled,
        className: "".concat(className, " border-primary hover:text-white border inline-block justify-center bg-transparent hover:bg-primary text-primary py-2 text-lg font-semibold px-5 rounded ").concat(disabled ? disabledClassName : "")
    }, rest), {
        children: children
    }));
};
var YelpButton = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        className: "inline-block w-full md:w-auto  border-gray-800 border justify-center bg-transparent hover:bg-gray-800 hover:text-white text-gray-800 py-2 text-lg font-semibold px-5 rounded",
        children: children
    });
};
var ViewAllCitiesButton = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        className: "inline-block border-allCitiesGray border justify-center bg-transparent hover:bg-allCitiesGray hover:text-white text-allCitiesGray py-2 text-lg font-semibold px-5 rounded",
        children: children
    });
};


/***/ }),

/***/ 97257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* binding */ FeatureBySection; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/Container.tsx
var Container = __webpack_require__(3210);
;// CONCATENATED MODULE: ./public/img/nbc-logo@grayscale-1024x266.png
/* harmony default export */ var nbc_logo_grayscale_1024x266 = ({"src":"/_next/static/media/nbc-logo@grayscale-1024x266.716bc1c2.png","height":266,"width":1024,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAG1BMVEV7e3t/f39MaXE+Pj5JSUlgYGBpaWlBQUFtbW0S8iZ+AAAACXRSTlOkAgCXssAzM8IzDEHQAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGklEQVR4nGNgZGLjYGVnYmRgZGJgYGFmYgQAAfYALur2UdUAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./public/img/business-insider-logo.png
/* harmony default export */ var business_insider_logo = ({"src":"/_next/static/media/business-insider-logo.c580027e.png","height":417,"width":1608,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAADFBMVEVubm5vb29ubm5tbW2is7ZZAAAABHRSTlNFN1MVwjbX/AAAAAlwSFlzAAALEwAACxMBAJqcGAAAABRJREFUeJxjYGJgYARhBmZGMIMZAACVABH1GLcLAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./public/img/aftermarket-news-logo.png
/* harmony default export */ var aftermarket_news_logo = ({"src":"/_next/static/media/aftermarket-news-logo.758a4f11.png","height":417,"width":1608,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAG1BMVEVMTExDQ0N9fX11dXVCQkJBQUFISEhpaWmQkJCptCviAAAACXRSTlMDcVNpVUoxKSU5ZKc7AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGklEQVR4nGNgYGBlYWRkY2Bg4GBmYmZiZwAAAWQAKzWo2m0AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./public/img/ratchet-wrench-logo@grayscale.png
/* harmony default export */ var ratchet_wrench_logo_grayscale = ({"src":"/_next/static/media/ratchet-wrench-logo@grayscale.dd903de4.png","height":130,"width":500,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAD1BMVEV3d3d2dnZ3d3d2dnZ0dHQNJw2BAAAABXRSTlNuf12QLh7GRWEAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAaSURBVHicY2BmYGRgYGZgYWBiZGBmZGRiAgAA0wAYqAGTeQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./src/components/FeatureBySection.tsx








var FeatureBySection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
        className: "max-w-full py-5 bg-white px-0",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "grid grid-cols-2 text-center gap-4 md:grid-cols-5",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-span-2 md:col-span-1 mb-2 md:mb-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        style: {
                            fontSize: 28,
                            fontWeight: 700
                        },
                        children: "Featured By"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        height: 40,
                        width: 160
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        className: "mx-auto",
                        src: nbc_logo_grayscale_1024x266,
                        alt: "NBC Logo"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        height: 40,
                        width: 140
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        className: "mx-auto",
                        src: business_insider_logo,
                        alt: "Business Insider Logo"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        height: 40,
                        width: 160
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: aftermarket_news_logo,
                        alt: "After Market Image Logo"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        height: 40,
                        width: 140
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        className: "mx-auto",
                        src: ratchet_wrench_logo_grayscale,
                        alt: "Ratchet + Wrench Logo"
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 17743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ LandingPageButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68663);
/* harmony import */ var _hooks_useQueryParam__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73401);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);








function LandingPageButton(props) {
    var query = (0,_hooks_useQueryParam__WEBPACK_IMPORTED_MODULE_4__/* .useQueryParam */ .W)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: {
            pathname: "/get-quote/",
            query: query
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                className: classnames__WEBPACK_IMPORTED_MODULE_5___default()(props.className),
                style: {
                    paddingTop: 8,
                    paddingBottom: 8,
                    paddingLeft: 25,
                    paddingRight: 25
                }
            }, props.buttonProps), {
                children: props.buttonText
            }))
        })
    });
}


/***/ }),

/***/ 49610:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ReviewsPage": function() { return /* binding */ ReviewsPage; },
  "default": function() { return /* binding */ reviews; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 14 modules
var lib = __webpack_require__(59397);
// EXTERNAL MODULE: ./src/components/clients/new-backend.client.ts
var new_backend_client = __webpack_require__(36826);
;// CONCATENATED MODULE: ./src/asyncLoaders/nest.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      query getReviewsMetaData {\n        getReviewsMetaData {\n          rating\n          reviewCount\n        }\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      query getReviews($cursor: String, $limit: Int) {\n        getReviews(cursor: $cursor, limit: $limit) {\n          edges {\n            reviewerName\n            reviewType\n            rating\n            comment\n            branch\n            dateCreated\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n      }\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var getReviewIODataFromNest = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var result, _getReviewsMetaData, reviewCount, rating;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        new_backend_client/* newBackendClient.query */.t.query({
                            query: (0,lib/* default */.ZP)(_templateObject())
                        })
                    ];
                case 1:
                    result = _state.sent();
                    _getReviewsMetaData = result.data.getReviewsMetaData, reviewCount = _getReviewsMetaData.reviewCount, rating = _getReviewsMetaData.rating;
                    return [
                        2,
                        {
                            reviewCount: reviewCount,
                            rating: rating
                        }
                    ];
            }
        });
    });
    return function getReviewIODataFromNest() {
        return _ref.apply(this, arguments);
    };
}();
var getReviews = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(options) {
        var ref, limit, cursor, result;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    limit = (options === null || options === void 0 ? void 0 : options.limit) || 50;
                    cursor = (options === null || options === void 0 ? void 0 : options.cursor) || null;
                    return [
                        4,
                        new_backend_client/* newBackendClient.query */.t.query({
                            query: (0,lib/* default */.ZP)(_templateObject1()),
                            variables: {
                                cursor: cursor,
                                limit: limit
                            }
                        })
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result === null || result === void 0 ? void 0 : (ref = result.data) === null || ref === void 0 ? void 0 : ref.getReviews
                    ];
            }
        });
    });
    return function getReviews(options) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/Container.tsx
var Container = __webpack_require__(3210);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-duotone-svg-icons/faShieldCheck.js
var faShieldCheck = __webpack_require__(68481);
// EXTERNAL MODULE: ./src/components/LandingPageButton.tsx
var LandingPageButton = __webpack_require__(17743);
// EXTERNAL MODULE: ./public/img/nubrakes-van-house-800-num.jpg
var nubrakes_van_house_800_num = __webpack_require__(5426);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
;// CONCATENATED MODULE: ./src/components/ReviewsPage/ReviewsPageTopSection.tsx








var ReviewPageTopSection = function(param) {
    var title = param.title, description = param.description;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "py-0",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col justify-center align-center",
            style: {
                height: "60vh",
                position: "relative",
                width: "100%"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: nubrakes_van_house_800_num/* default */.Z,
                    placeholder: "blur",
                    layout: "fill",
                    objectFit: "cover",
                    objectPosition: "bottom center",
                    priority: true,
                    alt: "NuBrakes Reviews Header Image"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "overlay",
                    style: {
                        minHeight: "100%",
                        width: "100%",
                        position: "absolute",
                        zIndex: 1,
                        backgroundColor: "rgba(0,0,0,.75)"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        zIndex: 2
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
                        className: "text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: "title text-white",
                                    children: title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "description text-white",
                                    children: description
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingPageButton/* LandingPageButton */.K, {
                                    buttonText: "Get A Free Brake Repair Estimate"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-row mt-4 gap-2 justify-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                            icon: faShieldCheck/* faShieldCheck */.ip,
                                            color: "#2D9CDB",
                                            size: "2x"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "description text-white",
                                            children: "NuBrakes never offers incentives for reviews"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@apollo/react-common/lib/react-common.esm.js
var react_common_esm = __webpack_require__(60118);
// EXTERNAL MODULE: ./node_modules/@apollo/react-ssr/lib/react-ssr.esm.js + 3 modules
var react_ssr_esm = __webpack_require__(37705);
// EXTERNAL MODULE: ./node_modules/next-with-apollo/lib/index.js
var next_with_apollo_lib = __webpack_require__(84763);
var lib_default = /*#__PURE__*/__webpack_require__.n(next_with_apollo_lib);
// EXTERNAL MODULE: ./node_modules/apollo-client/bundle.esm.js + 1 modules
var bundle_esm = __webpack_require__(97358);
// EXTERNAL MODULE: ./node_modules/apollo-cache-inmemory/lib/bundle.esm.js + 4 modules
var lib_bundle_esm = __webpack_require__(74291);
// EXTERNAL MODULE: ./node_modules/apollo-link/lib/bundle.esm.js + 1 modules
var apollo_link_lib_bundle_esm = __webpack_require__(72058);
// EXTERNAL MODULE: ./node_modules/apollo-link-error/lib/bundle.esm.js + 1 modules
var apollo_link_error_lib_bundle_esm = __webpack_require__(65558);
// EXTERNAL MODULE: ./node_modules/apollo-link-http/lib/bundle.esm.js + 4 modules
var apollo_link_http_lib_bundle_esm = __webpack_require__(42940);
;// CONCATENATED MODULE: ./src/components/withApolloHOC.tsx











/* harmony default export */ var withApolloHOC = (lib_default()(function(param) {
    var initialState = param.initialState;
    return new bundle_esm/* default */.ZP({
        link: apollo_link_lib_bundle_esm/* ApolloLink.from */.i0.from([
            (0,apollo_link_error_lib_bundle_esm/* onError */.q)(function(param) {
                var graphQLErrors = param.graphQLErrors, networkError = param.networkError;
                if (graphQLErrors) graphQLErrors.forEach(function(param) {
                    var message = param.message, locations = param.locations, path = param.path;
                    return console.log("[GraphQL error]: Message: ".concat(message, ", Location: ").concat(locations, ", Path: ").concat(path));
                });
                if (networkError) console.log("[Network error]: ".concat(networkError));
            }),
            new apollo_link_http_lib_bundle_esm/* HttpLink */.u({
                uri: new_backend_client/* newBackendUri */.c,
                credentials: "same-origin"
            }), 
        ]),
        connectToDevTools: true,
        cache: new lib_bundle_esm/* InMemoryCache */.h4().restore(initialState || {})
    });
}, {
    render: function(param) {
        var Page = param.Page, props = param.props;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_common_esm/* ApolloProvider */.eT, {
            client: props.apollo,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Page, (0,_object_spread/* default */.Z)({}, props))
        });
    },
    getDataFromTree: react_ssr_esm/* getDataFromTree */.J$
}));

// EXTERNAL MODULE: ./src/components/Layout.tsx + 1 modules
var Layout = __webpack_require__(22932);
// EXTERNAL MODULE: ./src/components/FeatureBySection.tsx + 4 modules
var FeatureBySection = __webpack_require__(97257);
;// CONCATENATED MODULE: ./src/pages/reviews.tsx




//import { useEffect } from 'react'

//import { Query, QueryGetReviewsArgs } from '../generated/nest-graphql'
//import gql from 'graphql-tag'


//import { ReviewsList } from '../components/ReviewsPage/ReviewsList'

//import { useQuery } from '@apollo/react-hooks'

//import { mergeDeepRight } from 'ramda'
//import { debounce } from 'debounce'


/*const GET_REVIEWS_QUERY = gql`
  query getReviews($cursor: String, $limit: Int) {
    getReviews(cursor: $cursor, limit: $limit) {
      edges {
        reviewerName
        reviewType
        rating
        comment
        branch
        dateCreated
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`*/ var ReviewsPage = function(props) {
    var reviewCount = props.reviewCount, rating = props.rating;
    /*const query = useQuery<Query, QueryGetReviewsArgs>(GET_REVIEWS_QUERY, {
    variables: {
      limit: 50,
    },
  })

  const loadMore = debounce(async () => {
    if (query && query.data && query.data.getReviews.pageInfo.hasNextPage) {
      await query.fetchMore({
        query: GET_REVIEWS_QUERY,
        variables: {
          cursor: query.data.getReviews.pageInfo.endCursor,
          limit: 50,
        },
        updateQuery: (prev, { fetchMoreResult }) => {
          if (!fetchMoreResult) return prev
          const updates = {
            getReviews: {
              edges: [...prev.getReviews.edges, ...fetchMoreResult.getReviews.edges],
              pageInfo: fetchMoreResult.getReviews.pageInfo,
            },
          }
          return fetchMoreResult.getReviews.edges.length ? mergeDeepRight(prev, updates) : prev
        },
      })
    }
    return null
  })*/ /*const listener = async (e) => {
    const scrollY = window.scrollY
    const topOffset = e.target.getElementsByTagName('footer')[0].offsetTop
    if (topOffset - scrollY < 2000) {
      //await loadMore()
    }*/ /*useEffect(() => {
    window.addEventListener('scroll', listener)
    return () => window.removeEventListener('scroll', listener)
  })*/ return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        title: "Reviews - NuBrakes Mobile Brake Repair",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "description",
                    content: "Find out why people love and trust using NuBrakes for affordable, convenient brake repairs delivered right where you’re parked at home or work!"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewPageTopSection, {
                title: "Trusted by Drivers Like You",
                description: "NuBrakes is rated ".concat(rating, "/5 by ").concat(reviewCount.toLocaleString("en-US"), " brake repair customers")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureBySection/* FeatureBySection */.x, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "p-1 w-screen",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            display: "none"
                        },
                        dangerouslySetInnerHTML: {
                            __html: '<script src="https://storyprompt.com/js/iframeResizer.min.js"></script>'
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                        loading: "eager",
                        id: "SP_5LvBBKBNirflE8PipN7F",
                        src: "https://storyprompt.com/wall/5LvBBKBNirflE8PipN7F",
                        frameBorder: "0",
                        width: "100%",
                        height: "800px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            display: "none"
                        },
                        dangerouslySetInnerHTML: {
                            __html: "<script>iFrameResize({checkOrigin: false, heightCalculationMethod: \"taggedElement\"}, '#SP_5LvBBKBNirflE8PipN7F');</script>"
                        }
                    })
                ]
            })
        ]
    });
};
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
ReviewsPage.getInitialProps = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
    var ref, reviewCount, rating;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    getReviewIODataFromNest()
                ];
            case 1:
                ref = _state.sent(), reviewCount = ref.reviewCount, rating = ref.rating;
                return [
                    2,
                    {
                        reviewCount: reviewCount,
                        rating: rating
                    }
                ];
        }
    });
});
/* harmony default export */ var reviews = (withApolloHOC(ReviewsPage, {
    getDataFromTree: react_ssr_esm/* getDataFromTree */.J$
}));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,4976,2978,1477,2932,2888,179], function() { return __webpack_exec__(19698); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);